import React, { ChangeEvent } from 'react';
import Modal from '@mui/material/Modal';
import { CsvModalStyle } from './csv-upload-modal.styled';
import i18n from '../../../../translations/strings';
import { SvgImage, SvgType } from '../../../../components/base/svg/svg';
import { CsvUploadModalTitle, CsvUploadModalVariant } from './constants';

interface CsvUploadModalProps {
  variant: CsvUploadModalVariant;
  isVisible: boolean;
  onModalClose: () => void;
  onCsvUpload: (file: any) => void;
}

const CsvUploadModal = (props: CsvUploadModalProps) => {
  const { variant } = props

  const handleFileSelection = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    handleFile(file);
  };

  const handleFile = (file: File | null) => {
    if (file && file.name.endsWith('.csv')) {
      props.onCsvUpload(file);
      props.onModalClose();
    } else {
      props.onModalClose();
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (
    <Modal
      open={props.isVisible}
      onClose={() => {
        props.onModalClose();
      }}
    >
      <CsvModalStyle.ModalContainerContent>
        <CsvModalStyle.ContentModal
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <CsvModalStyle.ContainerCloseButton onClick={() => props.onModalClose()}>
            <SvgImage type={SvgType.Close} />
          </CsvModalStyle.ContainerCloseButton>
          <CsvModalStyle.TitleModal>
            {CsvUploadModalTitle[variant]}
          </CsvModalStyle.TitleModal>
          <CsvModalStyle.SubTitleModalContainer>
            <CsvModalStyle.SubTitleModal>
              {i18n.t('reservations.uploadCsv')}
            </CsvModalStyle.SubTitleModal>
            {variant === CsvUploadModalVariant.Edit &&
              <CsvModalStyle.TextModalOverride>
                {i18n.t('reservations.overrideCsvUploadMessage')}
              </CsvModalStyle.TextModalOverride>
            }
          </CsvModalStyle.SubTitleModalContainer>
          <CsvModalStyle.TextModalContainer>
            <SvgImage type={SvgType.UploadCsv}/>
            <CsvModalStyle.TextModal>
              <CsvModalStyle.TextModalUnderline>
                {i18n.t('reservations.uploadDocument')}
              </CsvModalStyle.TextModalUnderline>{' '}
              {i18n.t('reservations.dragAndDrop')}
            </CsvModalStyle.TextModal>
            <input
              hidden
              type="file"
              accept=".csv"
              onChange={handleFileSelection}
            />
          </CsvModalStyle.TextModalContainer>
        </CsvModalStyle.ContentModal>
      </CsvModalStyle.ModalContainerContent>
    </Modal>
  );
};

export default CsvUploadModal;
